/** @jsx jsx */
import ProducersPage from '@bottlebooks/gatsby-theme-event/src/components/ProducersPage/ProducersPage';
import { graphql } from 'gatsby';
import deepMerge from 'lodash/merge';
import { jsx } from 'theme-ui';
import {
  extractProducerIdsForCharacteristics,
  getCharacteristicsForId,
} from '../helpers/brandCertifications';

export default function ProducersTemplate({
  data,
  pageContext,
  location,
  navigate,
}) {
  const { event, producers, site } = afterQuery(data);
  const { filterSeekingDistribution, filterHasDistribution } = event || {};
  return (
    <ProducersPage
      {...pageContext}
      event={event}
      producers={producers}
      facetConfig={{
        filterSeekingDistribution,
        filterHasDistribution,
        ...pageContext,
      }}
      siteTitle={site?.siteMetadata?.title}
      location={location}
      navigate={navigate}
    />
  );
}

function afterQuery({ bottlebooks, event, firstProducers, producers, site }) {
  const bb_event = bottlebooks?.event;
  const bb_producers = bb_event?.producers?.nodes;
  const combinedProducers = producers.nodes?.map((producer, index) => {
    const refinedData = firstProducers?.nodes[index];
    const bb_producer = bb_producers?.find(
      ({ producerId }) => producerId === producer.producerId
    );
    return deepMerge({}, producer, bb_producer, refinedData, {
      characteristics: getCharacteristicsForId({
        extractIdsFn: extractProducerIdsForCharacteristics,
        id: producer.producerId,
        event: bb_event,
      }),
    });
  });
  return {
    event,
    site,
    producers: combinedProducers,
  };
}

export const pageQuery = graphql`
  query ProducersTemplate(
    $eventId: ID!
    $locale: Bottlebooks_ContentLocale
    $filter: ProducerFilterInput
    $sort: ProducerSortInput
    $localeString: String
  ) {
    bottlebooks {
      event(eventId: $eventId, locale: $locale) {
        producers {
          nodes {
            producerId
            ...bb_ProducersPage
          }
        }
        registeredProducts {
          ...bb_BrandProductFilters_RegisteredProductConnection
        }
      }
    }
    event(locale: { eq: $localeString }) {
      ...ProducersTemplate_Event
    }
    firstProducers: allProducer(filter: $filter, sort: $sort, limit: 100) {
      nodes {
        ...ProducersPage_first
      }
    }
    producers: allProducer(filter: $filter, sort: $sort) {
      nodes {
        producerId
        ...ProducersPage
      }
    }
    ...ProducersTemplate_Query
  }

  fragment ProducersTemplate_Event on Event {
    filterSeekingDistribution
    filterHasDistribution
    ...ProducersPage_Event
  }

  fragment ProducersTemplate_Query on Query {
    site {
      siteMetadata {
        title
      }
    }
  }
`;
